// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-stadium-house -> aion-management-stadium-house -> cherry-hill-towers
// Generated: 2026-10-22T20:05:02.666Z
// Counts: 1 design, 98 content, 67 slot group, 0 collection binding, 9 section, 4 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesforyou.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities Built For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>YOUR NEW HOME AWAITS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "contact-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>WE'RE HERE TO HELP</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Frequently asked questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>THE COMFORTS OF HOME</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_floorplans_blurb"
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Make Yourself At Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.cta_banner_headline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Live your best life at <span data-type=\"field-token\" data-field=\"property_name\"></span>.</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>A STILL-SHOT OF YOUR NEW LIFE</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome To Cherry Hill Towers</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your space</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Find your space.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Cherry Hill Township</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Perfect location</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Furry friends welcome</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Because pets are family too.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_1_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet spa</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_2_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dog park</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.feature_3_title": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet-friendly restaurants</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet policy</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace Life in Your Perfect Apartment Community Today</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>ACCESS YOUR RESIDENT PORTAL</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Login</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentreview.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents say</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>In their own words</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "<h2>Hear it from our residents.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>your perfect apartment is here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "socialfeedsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Follow us on social media</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>360° views right here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "amenities-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>THE CONVENIENCE OF HOME</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-chatbot.position_side": {
    "overrideType": "VALUE",
    "customValue": "left",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/apartments-fitness-center-new-brunswick-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/apartments-fitness-center-new-brunswick-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Pet Policy</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Aside from anything and everything being blocks from your door at Cherry Hill Towers, you have access to an entire mix of remarkable indoor-outdoor lifestyle spaces, perfect for any mood. Looking for a little me time? Grab a book and relax in one of our luxury community amenities, or make the day better at the resort-style pool. Feeling energetic? Head to our 24-hour fitness studio for an empowering workout session. No matter what’s on the agenda, Cherry Hill Towers is ready to meet you there with the modern perks to simplify your life.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.headline": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesforyou.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Cherry Hill Towers, where modern living meets nature’s tranquility. Choose from stylish one or two-bedroom floor plans, and indulge in amenities like a sparkling swimming pool, scenic walking trails, and a vibrant pet-friendly atmosphere. Elevate your lifestyle today and experience the perfect blend of comfort and convenience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cherry Hill Towers, you’ll find a serene blend of modern comfort and vibrant community living in Cherry Hill Township, NJ. Enjoy spacious one and two-bedroom floor plans, resort-style amenities, and picturesque walking trails. Embrace an active lifestyle with our fitness center, dog park, and outdoor lounge. Lease your new home online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cherry Hill Towers in Cherry Hill Township, NJ, your perfect home awaits! Choose from stylish one-bedroom and spacious two-bedroom floor plans designed for comfort and convenience. Whether you're downsizing or seeking more space, our leasing team is here to help. Have questions? Contact us today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.administrative_fee": {
    "overrideType": "VALUE",
    "customValue": "$200",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.application_fee": {
    "overrideType": "VALUE",
    "customValue": "$50",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.community_amenity_fee": {
    "overrideType": "VALUE",
    "customValue": "$250",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.month_to_month_fee": {
    "overrideType": "VALUE",
    "customValue": "$350",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_fee": {
    "overrideType": "VALUE",
    "customValue": "$300",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.pet_rent": {
    "overrideType": "VALUE",
    "customValue": "$50",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.security_deposit": {
    "overrideType": "VALUE",
    "customValue": "$750",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_admin_billing_fee": {
    "overrideType": "VALUE",
    "customValue": "$4.53",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_electric": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_gas": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "feetransparency.utility_water_sewer": {
    "overrideType": "VALUE",
    "customValue": "Usage-Based (Utilities)",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>A luxurious home near Cherry Hill Mall in Camden County is just the start. The stylish finishes and modern perks you’ll find inside your private residence, think renovated kitchens and baths, in-unit washers and dryers, and large closets.</p><p>Check out our collection of community photos, then reach out to schedule your private tour to see it all in person today</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Cherry Hill Towers isn’t just easy on the eyes – it’s easy on the lifestyle. No matter your vibe, let this gem of a community take you into territory you’ve never seen before. Think resort-style pool with a sundeck and barbecue picnic pavilion. You were meant to meet Cherry Hill Towers. So start picturing the possibilities of what life is really like here.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 2 Bedroom Apartments in Cherry Hill Township , NJ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>You live in Camden County. What more is there to say? With a walkable location, you have it all just moments from your door. And if it’s a bit farther out of range, you’re conveniently close to several public transit options to be there in a matter of minutes. Diverse eateries, endless boutiques and storefronts, corner markets, coveted music venues, iconic city parks – it’s all here when you live at Cherry Hill Towers.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>This is elevated, iconic living in Camden County. The city is all around you when you live at Cherry Hill Towers. You’ll be living just steps from incredible dining destinations, entertainment hotspots, a buzzing nightlife scene, and pretty much anything else you’d want to experience. When you’re not living life to the max in an energetic area, you’ll be back at our luxe amenity spaces hanging out and making friends. With our high-end, upgraded one, two, and three bedroom apartment homes, you’ll be further treated to opening your front door to a pet-friendly luxurious retreat. So, welcome home. This is Cherry Hill Towers.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Cherry Hill Towers in Cherry Hill Township, NJ, where comfort meets style! With spacious one and two-bedroom floor plans tailored to your lifestyle, managing your home is effortless. Access your resident portal today to pay rent, schedule maintenance, and enjoy a seamless living experience!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cherry Hill Towers in Cherry Hill Township, NJ, your ideal living space awaits. Choose from stylish one- and two-bedroom apartments designed for comfort and convenience. Ready to envision your new home? Schedule a tour today and see what our residents love about life in our vibrant community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb_heading": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Cherry Hill Towers in beautiful Cherry Hill Township, NJ! Our stylish one and two-bedroom floor plans offer a perfect blend of comfort and elegance, tailored to your lifestyle. Keep an eye on your inbox—our team will connect with you soon to discuss your future home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into Cherry Hill Towers, where modern living meets comfort in Cherry Hill Township, NJ. Choose from thoughtfully designed one and two-bedroom apartments that suit your lifestyle. Immerse yourself in our vibrant community by taking a virtual tour today—your perfect home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "apply-now-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Apply Now"
      }
    }
  },
  "floorplanslist.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.cta_secondary_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Tour"
      }
    }
  },
  "footer.emergency_badge": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a159e7-a80b-77ee-97d6-e8506cb14dfb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "2-1-1 New Jersey logo"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your New Home"
      }
    }
  },
  "propertyoverview.cta_secondary": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your New Home"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "amenitiesforyou.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Swimming Pool with Sundeck"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-210d-75b7-9678-e07f5ce0951e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor pool with turquoise water, lounge chairs, and a white resort building under a blue sky"
      }
    }
  },
  "amenitiesforyou.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "24-Hour Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-3775-77fa-b2d0-e8a3ad23cd4e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern gym room with treadmills, exercise bikes, and weight equipment under bright overhead lights"
      }
    }
  },
  "amenitiesforyou.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Clubhouse with Resident Lounge"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-3db6-72cd-b3b4-5bcf5df82a46.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious modern resident lounge with blue walls, circular pendant lights, and comfortable seating."
      }
    }
  },
  "amenitiesforyou.amenity_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "VALUE",
        "customValue": "Game Room"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-373e-7120-9b0a-d39e02e4049b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Recreation room with a pool table, TV, couches"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd955-f754-71ed-ac9c-f1aecb12ba5c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in a modern apartment with a beige sofa, dark wood floor, shelves, and a large TV."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-3db6-72cd-b3b4-5bcf5df82a46.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious modern resident lounge with blue walls, circular pendant lights, and comfortable seating."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0267-e15b-779e-9cb2-08608431edad.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior community lounge with contemporary seating, a coffee table, and large glass doors opening to a balcony."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0268-06b1-70fa-967b-3b9c98face1d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cardio gym with three treadmills and a stationary bike against orange walls."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0268-04c8-734d-9d0a-1a460d138ab5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor community recreation room with a pool table, seating, and a wall-mounted TV."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0267-96e1-731a-b511-72abee03e699.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright, modern white kitchen with stainless steel appliances, sink, and white countertops."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0267-a42e-736e-998a-09114787c52a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom featuring a bed, a dark console with a mounted TV, a tall plant, and a window with cream curtains."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0267-9693-7555-9405-27e33377af97.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bathroom interior in a modern apartment with a white vanity, frosted glass shower, and toilet."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166312/019fd956-498f-74cc-9fe8-f5c4f70075ff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern, tall apartment building with white and gray facade and blue-tinted windows, surrounded by green trees."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0267-d20d-727c-a5d3-9bbde432e934.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor tennis court with nets, floodlights, and a chain-link fence beside trees."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0267-d111-760b-821d-53c30e634837.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Blue playground with slides and climbing structure in a grassy apartment community park."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0267-d4f9-74a8-a140-ea2536d6d9b8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fenced dog park with blue equipment in a grassy, tree-covered area."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019fd956-210d-75b7-9678-e07f5ce0951e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor pool with turquoise water, lounge chairs, and a white resort building under a blue sky"
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0267-f442-7197-8fea-356a03267eec.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor pool deck with lounge seating, tables, umbrellas, and a glass barrier."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0267-f756-704e-83fd-71d677ba6032.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community patio under a wooden pergola with a built-in grill and white dining tables."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0268-11a0-733f-aa6e-0cc83bf9e826.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor apartment community pool at dusk with lounge chairs along the deck."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$150"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$250"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.certificate": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Certificate of Occupancy"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$65"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$65"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.parking_covered": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Covered Parking Space"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.pet_fee_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "25"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.storage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Storage"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$30–$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500 - $1,000"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "hero.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "COOL Amenities"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Discover how our community makes life convenient and fun."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "hero.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "LUXURY HOMES"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Spaces designed for comfort, focus, and everyday living."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "hero.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": "APPLY"
      },
      "text": {
        "type": "VALUE",
        "customValue": "Fill out the contact form and be one step closer to applying."
      },
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-b182-70f9-b681-2d53071724b3.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Sunrise Social NJ"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Brunch & Cafe"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Trendy Golden Triangle spot specializing in brunch, with creative twists on breakfast and lunch favorites."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-205a-72cb-9281-bbb428167348.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Cherry Hill Mall"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Shopping & Retail"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Large, upscale shopping mall with favorite apparel, shoe & home stores, plus a range of eateries."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-0704-7160-b062-9a94106a4372.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Cooper River Park"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Parks & Outdoors"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Riverside park with a playground, track, picnic areas and trails, plus a boathouse and rowing on the water."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-bee6-75e1-acb8-db4e8f17f3a9.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "The Farm and Fisherman Tavern"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Restaurants"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Locally sourced fare served from breakfast through dinner in a modern eatery with an on-site market."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-de5c-70eb-a107-ad6ccd3e2289.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Barclay Farmstead Museum"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Arts & Culture"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.6"
      },
      "description": {
        "type": "VALUE",
        "customValue": "This Quaker farmhouse, gardens & trails offer guests a view of living history from the early 1800s."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0266-09ae-7415-8bac-bea39b7be956.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Challenge Grove Park"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Recreation & Trails"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "2.8"
      },
      "description": {
        "type": "VALUE",
        "customValue": "This 18-acre park features playgrounds, a bike path, picnic areas, sports facilities & a garden."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-a021-7430-b3e8-7996ebfbfca2.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Eddie V's Prime Seafood"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Bar & Lounge"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Elegant seafood & steak destination with a cocktail lounge featuring live jazz in the evenings."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-e60c-75df-9bb4-dd2ceeacdd23.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Freedom Mortgage Pavilion"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Live Music & Entertainment"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Large outdoor performing arts amphitheater that transforms into a smaller, enclosed venue for the winter season."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-a9d9-745a-a93c-6017021a6096.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Seasons 52"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Fine Dining"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Rotating menu of seasonal American dishes alongside international wines in an upscale, candlelit setting."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-dd8f-7052-b566-79da02428382.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "AMC Cherry Hill 24"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Entertainment"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Cinema hosting first-run films late into the night, plus arcade games and a snacks concession area."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-ed12-7572-b4b3-3f9037f1a310.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Walter K Gordon Theater"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Theater & Performances"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "6.5"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Theater, amphitheater and venue featuring musical performances, a dance academy and student-directed productions."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0265-a9d3-722d-9545-3d4ae858076e.webp"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Silver Diner"
      },
      "category": {
        "type": "VALUE",
        "customValue": "Late-Night Diner"
      },
      "distance": {
        "type": "VALUE",
        "customValue": "0.7"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Modeled after the classic American diner, this regional chain supplies comfort fare & jukebox tunes."
      }
    }
  },
  "propertyoverview.image_hero": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166312/019d0267-9607-757f-970b-14de0bdd8986.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright living room with a beige sectional sofa, round wooden coffee table, and large windows with a city view."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "_section.PetPolicyCallout": {
    "properties": {
      "paddingTop": "0px"
    }
  },
  "header.address_link": {
    "properties": {
      "paddingTop": "5px"
    }
  }
};
